// category listing

window.refreshMiniCart = function(open) {
    open = open || false;
    $.get('/shop/mini-cart/', function(response) {
        $('.mini-cart-content').html(response.content);
        $('.cart_count').html('(' + response.cart_quantity + ')');
        if (open) {
            $('.mini-cart-panel').addClass('open');
            $('.mini-cart-overlay').removeClass('hidden');
            $("body").addClass("no-scroll");
        }
    });
};

let rangeMin = 1;
let updatedRange = false;

function updatePriceRange(response){
    // console.log("Min " + response.min); console.log("Min V " + response.min_value); console.log("Max " + response.max); console.log("Max V " + response.max_value);
    if(response.min_value >= response.max_value){
        $('#price_filter').addClass('d-none');
    } else {
        $('#price_filter').removeClass('d-none');
        $('.range_input input').attr('min', response.min_value);
        $('.range_input input').attr('max', response.max_value);
        // console.log(updatedRange);
        if(updatedRange){
            $('.range_input .min').val(response.min);
            $('.range_input .max').val(response.max);
        } else {
            $('.range_input .min').val(response.min_value);
            $('.range_input .max').val(response.max_value);
        }
        updateRanges();
    }
}

function updateFilters(filters){
    filters.forEach(function(filter) {
    if(filter.count == 0){
        $('#filter_category_' + filter.id).addClass('d-none');
    } else {
        $('#filter_category_' + filter.id).removeClass('d-none');
        filter.variations.forEach(function(variation){
        $('#filter_' + variation.id).find('.count').html(variation.count);
        if(variation.count == 0){
            $('#filter_' + variation.id).addClass('d-none');
        } else {
            $('#filter_' + variation.id).removeClass('d-none');
        }
      });
    }
  });
}

function loadProducts(page = false){
    var form = $('#filter_form');
    var data = $('#filter_form').serialize();

    if(page){
        data = data + '&page=' + page;
    }

    $.get(form.attr('action'), data, function(response){
        // Update the product listing section with the new content
        $('#productSectionHandle .product_listing').replaceWith(response.product_content);
        $('.showing_products').html(response.showing_products);
        $('.total_products').html(response.total_products);
        $('.reset').removeClass('d-none');
        window.history.pushState('', '', '?' + data);
        // update filters & pricing range
        updateFilters(response.filters);
        updatePriceRange(response);
    });
}

$(document).on('change', '.filter_item input, #id_order, #id_per_page', function(){
    if ($(this).hasClass('subcategory_check')){
        $('.variation_filter_item input').prop('checked',false);
    }
    loadProducts();
});

$(document).on('change', '.range_input input', function(){
    let min_value = $('.range_input input.min').val();
    let max_value = $('.range_input input.max').val();
    $('.range_price input.min').val(min_value);
    $('.range_price input.max').val(max_value);
    loadProducts();
});

function updateRanges(el=false){
    let min_input = $('.range_input input.min');
    let minRange = parseInt(min_input.val());
    let max_input = $('.range_input input.max');
    let maxRange = parseInt(max_input.val());
    if (maxRange - minRange < rangeMin) {
        if(el){
        if(el.hasClass('min')){
            $('.range_input input.min').val(maxRange - rangeMin);
        } else {
            $('.range_input input.max').val(minRange + rangeMin);
        }
        } else {
        $('.range_input input.max').val(minRange + rangeMin);
        }
    }
    minRange = parseInt(min_input.val());
    maxRange = parseInt(max_input.val());
    let newValue = Number((min_input.val() - min_input.attr('min')) * 100 / (min_input.attr('max') - min_input.attr('min')));
    let newPosition = 10 - (newValue * 0.2);
    $('.range_selected').css('left', newValue + "%");
    $('.range_input .min_value').css('left', "calc("+ newValue + "% + " + newPosition +"px)");
    $('.range_input .min_value span').html('&pound;' + minRange);
    newValue = Number((max_input.val() - max_input.attr('min')) * 100 / (max_input.attr('max') - max_input.attr('min')));
    newPosition = 10 - (newValue * 0.2);
    // console.log(maxRange); // console.log(max_input.attr('max')); // console.log(max_input.attr('max') - max_input.attr ('min')); // console.log(max_input.attr('max') - maxRange);
    $('.range_selected').css('right', (max_input.attr('max') - maxRange) / (max_input.attr('max') - max_input.attr('min')) * 100 + "%");
    $('.range_input .max_value').css('left', "calc("+ newValue + "% + " + newPosition +"px)");
    $('.range_input .max_value span').html('&pound;' + maxRange);
}

$(document).on('input', '.range_input input', function(){
    updatedRange=true;
    updateRanges($(this));
});

$(document).on('click', '#reset_filters', function(e){
    e.preventDefault();
    $.get($(this).attr('href'), function(response){
        // Update the product listing section with the new content
        $('#productSectionHandle .product_listing').replaceWith(response.product_content);
        $('.filter_item input').prop('checked',false);
        $('.showing_products').html(response.showing_products);
        $('.total_products').html(response.total_products);
        updatedRange=false;
        updatePriceRange(response);
        window.history.pushState('', '', window.location.pathname);
        $('.reset').addClass('d-none');
    });
});

$(document).on('click', '.pagination_link', function(e){
    e.preventDefault();
    var page = $(this).attr('data-page');
    loadProducts(page);
});

//
// Product Detail
//
$(document).on('submit', '#variation_form', function(e){
    e.preventDefault();
    var form = $(this);
    $.post(form.attr('action'), $(form).serialize(), function(response){
        if(response.error){
            alert(response.error);
        } else {
            if(response.content){
                $('.cart_count').html(`(${response.cart_quantity})`);
                $('.in_cart_quantity').html(response.item_quantity);
                $('.in_cart').show();
                if(response.remaining <= 0){
                    $('.quantity_details').slideUp();
                    $('#add_to_cart').prop('disabled', true);
                }
                // Old Minicart
                $('#minicart').html(response.content);
                $('#minicart').slideDown();
                setTimeout(function(){
                    $('#minicart').slideUp();
                }, 5000);

                // New Mini Cart
                if ($(".shopping_cart").hasClass("mini-cart-trigger")) {
                    refreshMiniCart(true);
                } else {
                    // Scroll to the top of the page
                    window.scrollTo(0, 0);
                }
            }
        }
    });
});

window.updateVariations = function(variation_input){

    var variation_type = variation_input.closest('.variation_type');
    var type_id = variation_type.attr('data-type-id');
    
    // Handle radio vs select
    var variation_id;
    if(variation_input.is(':radio')){
        variation_id = variation_type.find('.variation_input:checked').val();
    } else {
        variation_id = variation_input.val();
    }

    if(!variation_id) return;

    var url = $('#variation_form').data('variation-url');
    var csrfmiddlewaretoken = document.getElementsByName('csrfmiddlewaretoken')[0].value;

    data = {'type_id': type_id, 'variation_id': variation_id, 'csrfmiddlewaretoken': csrfmiddlewaretoken}

    if (variation_type.hasClass('calculator-row')) {
        var previous_variations = $('.variation_type').not('calculator-row');
    } else {
        var previous_variations = variation_type.prevAll('.variation_type');
    }

    previous_variations.each(function(){
        var input = $(this).find('.variation_input');
        if(input.is('select')){
            data['type_' + $(this).attr('data-type-id')] = input.val();
        } else {
            data['type_' + $(this).attr('data-type-id')] = $(this).find('.variation_input:checked').val();
        }
    });

    $.post(url, data, function(response){
        if(response.error){
            console.log(response.error);
        } else if (response.future_variation_type){
            // $('.pricing').slideUp();
            if(response.allowed_variations){
                // alert(response.future_variation_type);
                let container = $('#variation_type_' + response.future_variation_type);
                container.find('.variation_item').addClass('d-none');
                // Disable all options in the select
                container.find('select option').attr('disabled', 'disabled').find(".stock").html('');
                let currentVal = container.find('select').val();
                let currentStillAvailable = false;

                // container.find('select option').prop('selected', false);
                // TODO: Hide swatches
                // container.find('.variation_swatch .variation_input').attr('disabled')
                // container.find('.variation_swatch .variation_input').attr('checked', false);
                // container.find('.variation_swatch .variation_input').prop('checked', false);

                container.find('.variation_swatch .variation_input').each(function(){
                    $(this).attr('disabled', 'disabled')
                    $(this).attr('checked', false);
                    $(this).prop('checked', false);
                });
                
                response.allowed_variations.forEach(function(item){
                    let displayType = $('#variation_item_' + item.v_id).parent().parent().data('display-type');
                    // alert(item.stock)
                    if (displayType == 'dropdown') {
                        // its a dropdown
                        if (item.stock <= 0 && item.stock != null){
                            $('#variation_item_' + item.v_id).attr('disabled', 'disabled');
                            $('#variation_item_' + item.v_id).find('.stock').html('(Out of Stock)');
                        } else {
                            $('#variation_item_' + item.v_id).removeAttr('disabled');

                            if (item.stock == null) {
                                $('#variation_item_' + item.v_id).find('.stock').html('(In Stock)');
                            } else {
                                $('#variation_item_' + item.v_id).find('.stock').html('(' + item.stock + ')');
                            }

                            $('#variation_item_' + item.v_id).removeClass('d-none');
    
                            if ($('#variation_item_' + item.v_id).val() == currentVal) {
                                currentStillAvailable = true;
                            }
                        }
                    } else {
                        // its a radio (I Think)
                        if (item.stock <= 0 && item.stock != null){
                            $('#variation_item_' + item.v_id).find('.variation_swatch .variation_input').attr('disabled', 'disabled');
                            $('#variation_item_' + item.v_id).find('.stock').html('(Out of Stock)');
                            $('#variation_item_' + item.v_id).removeClass('d-none');
                            $('#variation_item_' + item.v_id).find('.oos-label').removeClass('d-none');
                        } else {
                            $('#variation_item_' + item.v_id).find('input').removeAttr('disabled');
                            $('#variation_item_' + item.v_id).find('.stock').html('(' + item.stock + ')');
                            $('#variation_item_' + item.v_id).removeClass('d-none');
                            $('#variation_item_' + item.v_id).find('.oos-label').addClass('d-none');
                            
                            if ($('#variation_item_' + item.v_id).find('.variation_swatch .variation_input').val() == currentVal) {
                                currentStillAvailable = true;
                            }
                        }
                    }

                });

                if (!currentStillAvailable) {
                    // alert("Hello")
                    // Handle select
                    let firstAvailableOption = container.find('select option:not([disabled])').first();
                    if (firstAvailableOption.length) {
                        container.find('select').val(firstAvailableOption.val());
                    }
                
                    // Handle radios
                    let firstAvailableRadio = container.find('input[type="radio"]:not([disabled])').first();
                    if (firstAvailableRadio.length) {
                        firstAvailableRadio.prop('checked', true);
                    }
                }
            }
            var future_variation_type = $('#variation_type_' + response.future_variation_type);
            future_variation_type.removeClass('d-none');

            var next_input = future_variation_type.find('.variation_input:checked, select.variation_input').first();
            if(next_input.length){
                updateVariations(next_input);
            }
        } else if (response.variation_price) {
            if ($('.calculator')) {
                $('.calculator').data('unit-price', response.variation_price);
                var root = document.querySelector('.calculator');
                if (root) {
                    root.dataset.unitPrice = response.variation_price;
                }
            }
            if(response.cart_quantity > 0){
                $('.in_cart .in_cart_quantity').html(response.cart_quantity);
                $('.in_cart').show()
            } else {
                $('.in_cart').hide();
            }
            $('.product_price').html(response.variation_price);

            if (response.stock == null) {
                // Stock is not managed for this variation
                $('.product_availability').html(" In Stock");
            } else {
                $('.product_availability').html(response.stock);
            }
            
            $('.product_sku_value').html(response.sku);
            $('.product_subtotal').html(response.variation_price);

            if (response.compare_at_price != null) {
                $('.compare_at_price').removeClass('d-none');
                $('.product_compare_at_price').html(response.compare_at_price);
            } else {
                $('.compare_at_price').addClass('d-none');
            }

            if(response.image_ids && response.image_ids.length){
                var imageIds = response.image_ids.map(String);
                var $subImages = $('.sub_image[data-has-variation="True"]');
                var $matching = $subImages.filter(function(){
                    return imageIds.indexOf(String($(this).data('image-id'))) !== -1;
                });

                $subImages.hide();
                $matching.show();

                var $first = $matching.first();
                if($first.length){
                    var mainSrc = $first.data('main-src');
                    var lightboxSrc = $first.data('lightbox-src');
                    var title = $first.data('title');
                    var $mainLink = $('.main_image > a').first();
                    if(mainSrc){
                        $mainLink.find('img').attr('src', mainSrc);
                    }
                    if(lightboxSrc){
                        $mainLink.attr('href', lightboxSrc);
                    }
                    if(title){
                        $mainLink.attr('data-title', title);
                    }
                }
            }
            
            if(response.quantity_available > 0){
                if(response.quantity_available == 1){
                    $('.quantity').hide();
                } else {
                    $('.quantity').show();
                }
                $('.out_of_stock').hide();
                $('#quantity_field').val(1);
                $('#quantity_field').attr('max', response.quantity_available);
                $('#add_to_cart').prop('disabled', false);
                $('#out_of_stock_text').addClass("d-none");
                $('.quantity_details').show();
            } else {
                $('.quantity_details').hide();
                $('#add_to_cart').prop('disabled', true);
                $('#out_of_stock_text').removeClass("d-none");
                if(response.cart_quantity > 0){
                    $('.out_of_stock p').html('Sorry, you can\'t buy more than <strong>' + response.cart_quantity + '</strong> of this product.');
                } else {
                    $('.out_of_stock p').html('Sorry, this product is out of stock.');
                }
                $('.out_of_stock').show();
            }
            $('.pricing').slideDown();
        }
    });
}

/* Update images based on variations chosen - currently not implemented
if(response.image_ids){
    $('.sub_image').hide();
    $('.sub_image a').removeAttr('data-lightbox');
    for(key in response.image_ids){
        image_id = response.image_ids[key];
        $('.sub_image_' + image_id).show();
        $('.sub_image_' + image_id + ' a').attr('data-lightbox', 'product_images');
    }
} */

$(document).on('change', '.variation_input', function(){    
    updateVariations($(this));
});

$('#product_detail .plus').on('click', function () {
    var input = $("#quantity_field");
    var current_val = parseInt(input.val());
    var max_value = parseInt(input.attr('max'));
    if (current_val < max_value){
        input.val( parseInt(input.val()) + 1 ).change();
    }
});

$('#product_detail .minus').on('click', function () {
    var input = $("#quantity_field");
    current_val = parseInt(input.val());
    if(current_val > 1){
        input.val( parseInt(input.val()) - 1 ).change();
    }
});

$('#quantity_field').on('change', function () {
    var current_val = $(this).val();
    var price = $('.product_price').text();
    var max_value = parseInt($(this).attr('max'));
    console.log(max_value);
    console.log(current_val);
    if (current_val > max_value){
        current_val = max_value;
    }
    $(this).val(current_val);
    subtotal = parseFloat(price) * current_val;
    $('.product_subtotal').text(subtotal.toFixed(2));
});


$('.tab').on('click', function () {
    $('.tab').removeClass('active');
    $(this).addClass('active');
    var id = $(this).data('sectionid');
    $('.tab-info').removeClass('active');
    $('.tab-info').each(function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
        } else if ($(this).data('sectionid') == id) {
            $(this).addClass('active');
        }
    });
});

$('#related_products .products').slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: true,
    appendArrows: '#related_products .arrows',
    appendDots: '#related_products .dots',
    prevArrow: '<button type="button" class="slick-prev"><i class="fa-solid fa-chevron-left"></i></button>',
    nextArrow: '<button type="button" class="slick-prev"><i class="fa-solid fa-chevron-right"></i></button>',

    responsive: [{
        breakpoint: 1024,
        settings: {
            slidesToShow: 3,
            dots: false,
            slidesToScroll: 3,
            
        }
    }, {
        breakpoint: 600,
        settings: {
            slidesToShow: 2,
            dots: true,
            slidesToScroll: 2,
            arrows: false,
        }
    }]
});
